module.exports = __webpack_public_path__ + "static/media/Purple.79a6f23c.mp4";